import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
const isFor = ['Mujeres que se sienten "estancadas" en su carrera o vida personal.', 'Personas que sufren de ansiedad por comparación y perfeccionismo.', 'Quienes sienten síntomas físicos de estrés (nudos en la garganta, peso en el pecho).', 'Mujeres que desean una espiritualidad práctica y directa, sin complicaciones.'];
const isNotFor = ['Personas que buscan una solución mágica sin realizar los ejercicios físicos.', 'Quienes prefieren la teoría extensa sobre la práctica inmediata.', 'Buscadores de contenido gratuito que no valoran un método estructurado de intervención.'];
export function TargetAudienceSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 border-y border-zinc-800/50" data-id="element-153">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24" data-id="element-154">
        {/* Who this is for */}
        <div data-id="element-155">
          <FadeIn data-id="element-156">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-zinc-100" data-id="element-157">
              Para quién es esto
            </h2>
          </FadeIn>
          <div className="space-y-6" data-id="element-158">
            {isFor.map((text, i) => <FadeIn key={i} delay={0.1 * i} direction="right" data-id="element-159">
                <div className="flex items-start gap-4" data-id="element-160">
                  <div className="mt-1 bg-green-500/10 p-1 rounded-full shrink-0" data-id="element-161">
                    <Check className="w-4 h-4 text-green-500" data-id="element-162" />
                  </div>
                  <p className="text-zinc-300 leading-relaxed" data-id="element-163">{text}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        {/* Who this is NOT for */}
        <div data-id="element-164">
          <FadeIn data-id="element-165">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-zinc-500" data-id="element-166">
              Para quién NO es
            </h2>
          </FadeIn>
          <div className="space-y-6" data-id="element-167">
            {isNotFor.map((text, i) => <FadeIn key={i} delay={0.1 * i} direction="left" data-id="element-168">
                <div className="flex items-start gap-4 opacity-70" data-id="element-169">
                  <div className="mt-1 bg-red-500/10 p-1 rounded-full shrink-0" data-id="element-170">
                    <X className="w-4 h-4 text-red-500" data-id="element-171" />
                  </div>
                  <p className="text-zinc-400 leading-relaxed" data-id="element-172">{text}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}